__webpack_require__.p = "https://exported-appliction.yad2.co.il/system-pages/_next/";